<template>
  <div class="w-lg-600px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
    <div class="text-center mb-10">
      <h1 class="text-dark mb-3">{{ $t("Désabonnement notifications ticket") }}</h1>
      <p v-if="!state.submitted" class="text-gray-700">
        {{ $t("Saisissez votre adresse e-mail pour vous désabonner des notifications de ce ticket.") }}
      </p>
    </div>

    <div v-if="state.loading" class="text-center text-gray-700">
      {{ $t("Traitement en cours...") }}
    </div>

    <div v-else-if="state.submitted && state.ok" class="text-center">
      <div class="text-success fw-bold fs-4 mb-4">{{ $t("Désabonnement confirmé") }}</div>
      <p class="text-gray-700 mb-6">
        {{ $t("Vous ne recevrez plus les e-mails de notification ticket StillOnline.") }}
      </p>
      <p v-if="state.email" class="text-gray-600 mb-6">{{ state.email }}</p>
    </div>

    <div v-else-if="state.submitted && !state.ok" class="text-center">
      <div class="text-danger fw-bold fs-4 mb-4">{{ $t("Désabonnement impossible") }}</div>
      <p class="text-gray-700 mb-6">
        {{ $t("Aucun abonnement trouvé pour cette adresse e-mail sur ce ticket.") }}
      </p>
    </div>

    <form
      v-else
      class="form w-100"
      @submit.prevent="submitUnsubscribe"
    >
      <div class="fv-row mb-8">
        <label class="form-label fw-bold text-gray-800">{{ $t("Adresse e-mail") }}</label>
        <input
          v-model="state.email"
          type="email"
          class="form-control form-control-lg"
          required
          autocomplete="email"
        />
      </div>
      <div class="d-flex flex-wrap justify-content-center gap-3 pb-lg-0">
        <button type="submit" class="btn btn-lg btn-primary fw-bolder" :disabled="state.loading">
          {{ $t("Valider le désabonnement") }}
        </button>
        <router-link to="/sign-in" class="btn btn-lg btn-light-primary fw-bolder">
          {{ $t("Retour à la page de connexion") }}
        </router-link>
      </div>
    </form>

    <div
      v-if="state.submitted"
      class="d-flex flex-wrap justify-content-center pt-8"
    >
      <router-link to="/sign-in" class="btn btn-lg btn-light-primary fw-bolder">
        {{ $t("Retour à la page de connexion") }}
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

export default defineComponent({
  name: "notif-unsubscribe",
  setup() {
    const route = useRoute();
    const ticRef = String(route.params.ticRef || "");
    const state = reactive({
      loading: false,
      submitted: false,
      ok: false,
      email: "",
    });

    const submitUnsubscribe = async () => {
      if (!ticRef || !state.email.trim()) {
        return;
      }
      state.loading = true;
      try {
        const baseUrl = process.env.VUE_APP_BACK_URL || "";
        const response = await axios.post(
          `${baseUrl}/unsubscribeNotifTicket`,
          {
            tic_ref: ticRef,
            email: state.email.trim(),
          },
          { withCredentials: true }
        );
        const result = response.data?.results || response.data;
        state.ok = !!result?.ok;
        state.submitted = true;
      } catch {
        state.ok = false;
        state.submitted = true;
      } finally {
        state.loading = false;
      }
    };

    return { state, submitUnsubscribe };
  },
});
</script>
